import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Divider, Typography } from '@mui/material';
import Actions from './actions';
import Steps from './steps';
const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minWidth: theme.spacing(45),
    position: 'sticky',
    top: 0,
}));
const Title = styled(Typography)(({ theme }) => ({
    paddingBottom: theme.spacing(2),
}));
const ColumnStepper = ({ title, steps, step = 0, isNextDisabled = false, nextLabel = 'Next', previousLabel = 'Previous', completeLabel = 'Complete', handleStepClick, handleNext, handlePrevious, handleComplete, }) => {
    return (_jsxs(Root, { children: [_jsx(Title, Object.assign({ variant: "h5" }, { children: title })), _jsx(Divider, {}), _jsx(Steps, { steps: steps, step: step, handleStepClick: handleStepClick }), _jsx(Actions, { steps: steps, step: step, isNextDisabled: isNextDisabled, nextLabel: nextLabel, previousLabel: previousLabel, completeLabel: completeLabel, handleNext: handleNext, handlePrevious: handlePrevious, handleComplete: handleComplete })] }));
};
export default ColumnStepper;
//# sourceMappingURL=index.js.map